import React from 'react';
import Link from '@material-ui/core/Link';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import {Error, Warning} from '@material-ui/icons';

// Generate Order Data
function createData(id, date, name, shipTo, paymentMethod, amount) {
    return {id, date, name, shipTo, paymentMethod, amount};
}

const rows = [
    createData(0, '10 Nov, 2020', 'Alexandru Adameșteanu', 'Timișoara', 'Work Safety', <Error color="primary"/>),
    createData(1, '10 Nov, 2020', 'Anonymous', 'Pedroucos', 'Work Safety', ""),
    createData(2, '10 Nov, 2020', 'Anonymous', 'Timișoara', 'Environmental Grievance', <Warning color="primary"/>),
    createData(3, '9 Nov, 2020', 'Mihaela Budescu', 'Timișoara', 'Harassment', <Warning color="primary"/>),
    createData(4, '9 Nov, 2020', 'João Pereira', 'Pedroucos', 'Compensation', ""),
];

function preventDefault(event) {
    event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
}));

export default function Orders() {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Title>Recent Grievances</Title>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Complainant</TableCell>
                        <TableCell>Location</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Priority</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id} selected={row.id === 0}>
                            <TableCell>{row.date}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.shipTo}</TableCell>
                            <TableCell>{row.paymentMethod}</TableCell>
                            <TableCell>{row.amount}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <div className={classes.seeMore}>
                <Link color="primary" href="#" onClick={preventDefault}>
                    See more grievances
                </Link>
            </div>
        </React.Fragment>
    );
}
